import * as Colors from 'material-ui/styles/colors';

export default {
  labelWrapper: {
    padding: '15px',
    cursor: 'pointer',
    boxSizing: 'border-box',
    height: '50px'
  },
  labelWrapperInner: {
    width: '200px',
    fontFamily: 'Roboto, sans-serif',
    fontSize: '16px',
    display: 'flex',
    justifyContent: 'space-between'
  },
  labelWrapperInnerSpan: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    width: '100%'
  },
  labelWrapperInnerFontIcon: {
    position: 'relative',
    top: '-2px'
  },
  textFieldInputWrapper: {
    width: '200px',
    marginLeft: '15px',
    marginRight: '15px',
    marginTop: '1px'
  }
};
